
import GenreMaker from '../echart/genreMaker';
import * as DataMaker from '../echart/echartData';


var BarChart = class BarChart extends GenreMaker {

  getChart(subGenre,data,theme){

    echarts.init(document.getElementById('container')).dispose();


    var option = new Object();
    option.chart = new Object();
    option.title={text:"图形预览",x:'center'};
    option.tooltip={trigger:"axis"};
    option.xAxis=[{type:'value'}];

     var data = option;
    switch (subGenre) {
      case "bar":
        option.yAxis=[{type:'category',data:['Department Stores1','Discount Stores','Specialty Stores','Juvenile Specialty','All other outlets']}];
        option.series=[{name:'蒸发量',type:'bar',data:[737166, 537166, 188662, 178662, 89000]}];
        data = option;
        break;

      case "series":
        option.yAxis=[{type:'category',data:['QTR1','QTR2','QTR3','QTR4']}];
        option.series=[{name:'A',type:'bar',data:[3.8,5.5,9.9,5.7]},{name:'b',type:'bar',data:[5.5,7.0,9.7,7.6]},{name:'c',type:'bar',data:[6.9,9.6,8.3,9.7]}];
        data = option;
        break;
      case "stacked":
        option.yAxis=[{type:'category',data:['QTR1','QTR2','QTR3','QTR4']}];
        option.series=[{name:'A',type:'bar',stack: '1',data:[3.8,5.5,9.9,5.7]},{name:'b',type:'bar',stack: '1',data:[5.5,7.0,9.7,7.6]},{name:'c',type:'bar',stack: '1',data:[6.9,9.6,8.3,9.7]}];
        data = option;
        break;
      default:

    }


    switch(theme) {
      case "roma":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/roma')).setOption(data);
      break;
      case "sakura":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/sakura')).setOption(data);
      break;
      case "shine":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/shine')).setOption(data);
      break;
      case "default":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/default')).setOption(data);
      break;

      case "infographic":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/infographic')).setOption(data);
      break;

      case "macarons":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/macarons')).setOption(data);
      break;

      case "blue":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/blue')).setOption(data);
      break;

      case "dark":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/dark')).setOption(data);
      break;

      case "gray":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/gray')).setOption(data);
      break;

      case "green":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/green')).setOption(data);
      break;

      case "helianthus":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/helianthus')).setOption(data);
      break;

      case "mint":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/mint')).setOption(data);
      break;

      case "red":
        echarts.init(document.getElementById('container'),require('../../static/echarttheme/red')).setOption(data);
      break;
      default:
    }
        
        return echarts.init(document.getElementById('container'));
  }

}



GenreMaker.bar = BarChart;

export var BarChart;



// WEBPACK FOOTER //
// ./src/echart/barChart.js